'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginComponent = exports.sagas = exports.actions = exports.reducers = exports.constants = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _Container = require('./Container');

Object.defineProperty(exports, 'LoginComponent', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Container).default;
    }
});

var _immutable = require('redux-form/immutable');

var _constants = require('../constants');

var constants = _interopRequireWildcard(_constants);

var _reducer = require('../reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = require('./actions');

var loginComponentActions = _interopRequireWildcard(_actions);

var _sagas = require('./sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _loginForm = require('../login-form');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = {
    form: _immutable.reducer,
    loginComponent: _reducer2.default
};

var actions = (0, _extends3.default)({}, loginComponentActions, _loginForm.actions);

var sagas = [].concat((0, _toConsumableArray3.default)(_loginForm.sagas), [_sagas2.default]);

exports.constants = constants;
exports.reducers = reducers;
exports.actions = actions;
exports.sagas = sagas;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/index.js
// module id = 486
// module chunks = 0